import { render } from "./FIRSTRobot.vue?vue&type=template&id=6117a416&scoped=true"
import script from "./FIRSTRobot.vue?vue&type=script&lang=js"
export * from "./FIRSTRobot.vue?vue&type=script&lang=js"

import "./FIRSTRobot.vue?vue&type=style&index=0&id=6117a416&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6117a416"]])

export default __exports__